import { Dimensions } from 'react-native';

export const rowHeight = 78;

export const columnWidthsDesktop = {
  info: 5,
  name: 25,
  requester: 10,
  channel: 15,
  blockingDate: 15,
  status: 15,
  confirm: 15,
};

export const maxHeight = `${
  Dimensions.get('window').height - Dimensions.get('window').height * 0.5
}px`;

export const maxHeightMobile = `${
  Dimensions.get('window').height - Dimensions.get('window').height * 0.25
}px`;
